import React from "react";

export const InstallerList = ({ formData, setFormData, List }) => {
  const handleChangeInput = (e) => {
    console.log("working...");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <div>
      <label
        htmlFor="state"
        className="block mb-2 text-sm font-medium text-gray-900 "
      >
        Select Installer
        <span className="text-red-500 fixed h-3">*</span>
      </label>
      <select
        name="installerId"
        onChange={handleChangeInput}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5  dark:focus:ring-blue-500 dark:focus:border-blue-500"
      >
        {formData?.installerId === "" ? (
          <option>Select Installer</option>
        ) : (
          <option disabled>Select State</option>
        )}
        {List?.map(({ name, _id }, index) => (
          <option key={index} value={_id}>
            {name}
          </option>
        ))}
      </select>
    </div>
  );
};
